module.exports = __webpack_public_path__ + "img/img_doc_signature@2x.6cdaa033.png";